import { FileFormat } from "@components/molecules/Share/components/DownloadCSVModal";

export type ExportResult = {
  message: string;
  export: Export;
  success: boolean;
};

export type Export = {
  id: number;
  completed_at: string;
  created_at: number;
  error_message: string;
  export_type: number;
  file_format: FileFormat;
  file_url: string;
  max_items: number;
  processed_count: number;
  progress: number;
  retry_count: number;
  status: ExportStatus;
  total_count: number;
  total_items: number;
};

export type ExportResults = {
  exports: Export[];
  success: boolean;
};

export enum ExportStatus {
  denied = "denied",
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
  pending = "pending",
  downloaded = "downloaded",
  hidden = "hidden",
}
